import { Directive, TemplateRef } from '@angular/core';
import { TopbarService } from '../services/topbar.service';

@Directive({
    selector: '[appTopbarTemplate]',
    standalone: false
})
export class TopbarTemplateDirective {

  constructor(host: TemplateRef<any>, private topbarService : TopbarService) { 
    this.topbarService.template = host;
  }

}
